import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import ContentField, { ContentFieldPropsType } from "../ContentField";
import ContentValue, { ContentValuePropsType } from "../ContentValue";
import { ReactNode } from "react";
import DynamicFontSize from "../DynamicFontSize";
interface LineContentValueV2PropsType extends GeneralPropsType, ContentValuePropsType, ContentFieldPropsType {
  field?: ReactNode;
  value?: ReactNode;
  filedClassName?: string;
  valueClassName?: string;
}
function LineContentValueV2({
  field,
  value,
  filedClassName,
  valueClassName,
  className
}: LineContentValueV2PropsType) {
  return <div className={clsx("flex items-center justify-between gap-2", styles.container, className)} data-sentry-component="LineContentValueV2" data-sentry-source-file="index.tsx">
            <DynamicFontSize fontSize={13} className={clsx("text-description leading-[140%] font-medium", filedClassName)} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                {field}
            </DynamicFontSize>
            <DynamicFontSize fontSize={14} className={clsx("text-white leading-[140%] font-medium", valueClassName)} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                {value}
            </DynamicFontSize>
        </div>;
}
export default LineContentValueV2;